export default "__VITE_ASSET__B8vSXON1__"